import React from 'react';
import { P160ClubPage as P160ClubPageType } from '~/lib/data-contract';
import { DynamicBlockList } from '~/templates/blocks';
import { usePage } from '~/templates/pages';

export const P160ClubPage = () => {
    const { pageElements = [] } = usePage<P160ClubPageType>();
    return <DynamicBlockList elements={pageElements} />;
};
